import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "../api/axios";
import Cookies from "universal-cookie";
import { COMPANY_ID, TOKEN_NAME, PRODUCT_SLUG } from "../config";

const cookies = new Cookies();

const useRead = (data) => {
  const {
    url,
    initialData,
    onSuccess,
    onError,
    enabled = true,
    onSettled,
    method = "POST",
  } = data;
  const [paramsObject, setGetListParams] = useState(initialData);

  const list = useQuery([url, paramsObject], () => getUsers(paramsObject), {
    refetchOnWindowFocus: false,
    enabled: enabled,
    onSuccess(data) {
      onSuccess?.(data, paramsObject);
    },
    onError(err) {
      onError?.(err);
    },
    onSettled() {
      onSettled?.();
    },
  });

  const getUsers = async (paramsObject) => {
    let token = cookies.get(TOKEN_NAME);
    const companyId = cookies.get(COMPANY_ID);

    // If the method is GET, use query parameters
    if (method.toUpperCase() === "GET") {
      // Merge company_id and product_slug with other params into a single object
      const params = { company_id: companyId, product_slug: PRODUCT_SLUG, ...paramsObject };
      const response = await axios({
        method: "GET",
        url: `/${url}`,
        params: params,
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      return response.data;
    } else {
      // For POST (or other methods that support a body), use FormData
      let fd = new FormData();
      fd.append("company_id", companyId);
      fd.append("product_slug", PRODUCT_SLUG);
      for (let key in paramsObject) {
        fd.append(key, paramsObject[key]);
      }
      const response = await axios({
        method: method,
        url: `/${url}`,
        data: fd,
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      return response.data;
    }
  };

  return { list, paramsObject, setGetListParams };
};

export default useRead;
